import ApiClient from './ApiClient';

class ProspectWebhooksAPI extends ApiClient {
  constructor() {
    super('prospect_webhooks', { accountScoped: true });
  }
}

export default new ProspectWebhooksAPI();
